<template>
  <v-page page="profile">
    <p class="title">Profile</p>
      <v-card>
        <v-card-text>
          <dl class="dl-align">
            <dt><v-icon small>email</v-icon> Email</dt>
            <dd>{{ currentLogin }}</dd>

            <dt><v-icon small>card_travel</v-icon> Role</dt>
            <dd>{{ currentRole }}</dd>

            <template v-if="isImbellusUser">
              <dt v-if="isImbellusUser"><v-icon small>domain</v-icon> Companies</dt>
              <dd style="display: block">
                <div v-for="(company, companyKey) in currentCompaniesList" :key="`company-${companyKey}`">
                <v-icon :color="company.name === currentCompany ? 'success darken-1' : 'grey'" small class="mr-1">flash_on</v-icon> {{ company.name }}
                </div>
              </dd>
            </template>

          </dl>
        </v-card-text>
      </v-card>
      <v-expansion-panels v-if="isImbellusUser">
        <v-expansion-panel class="mt-2">
          <template v-slot:header>
            <strong>Token Credentials</strong>
          </template>
          <dl class="dl-card-align ml-3">
            <dt><v-icon small>lock</v-icon> Token</dt>
            <dd><clipboard :value="token">{{ token.substring(0, 32) }}...</clipboard></dd>
            <dt><v-icon small>computer</v-icon> Shell</dt>
            <dd><div class="shell">
            <clipboard :value="shellCommands">{{ shellCommands }}</clipboard>
          </div>
          </dd>
          </dl>
        </v-expansion-panel>
      </v-expansion-panels>
  </v-page>
</template>

<script>
import VPage from '@/layouts/Default'
import CurrentSession from '@/mixins/CurrentSession'
import Clipboard from '@/components/Clipboard'
import { servers } from '@/helpers'

export default {
  components: {
    VPage,
    Clipboard
  },
  mixins: [
    CurrentSession
  ],
  data () {
    return {
      token: this.$store.state.auth.originalToken
    }
  },
  computed: {
    shellCommands () {
      const token = this.$store.state.auth.originalToken
      const platformUrl = servers[this.$store.state.auth.server].platform
      const warehouseUrl = servers[this.$store.state.auth.server].scores
      const assetsUrl = servers[this.$store.state.auth.server].asset_manager
      return `export IMB_PLATFORM_URL=${platformUrl}
export IMB_WAREHOUSE_URL=${warehouseUrl}
export IMB_ASSETS_URL=${assetsUrl}
export IMB_API_TOKEN=${token}`
    }
  }
}
</script>

<style lang="sass">
.shell
  background-color: #ddd
  padding: 5px
  margin-right: 5px
  font-family: monospace
  white-space: pre
  overflow: hidden
</style>
